<waitLoading *ngIf="!isLoaded()"></waitLoading>
<div class="wrapper wrapper-content ng-scope animated fadeInRight" *ngIf="isLoaded()">
  <dossierHeader [title]="'Timers'" [titleIcon]="'fa fa-file'"></dossierHeader>
  <div class="buttonsHeader">
    <button class="btn btn-outline-secondary" type="button" class="btn btn-outline-secondary" aria-expanded="false"
      (click)="uiService.routeBack()">
      <i class="fas fa-chevron-left" aria-hidden="true"></i>
      <span class="d-none d-md-inline"> {{ 'General.back' | translate }}</span>
    </button>
  </div>
  <div class="container-fluid ">
    <div class="row m-t-md" *ngIf="isActiveNode != undefined">
      <div class="col-12 alert alert-warning">
        <div class="col-12"><i class="fas fa-1-5x fa-exclamation-circle m-r-md"></i> {{ 'timers.cluster.info' |
          translate
          }}</div>
        <div class="col-12">
          <span><b>{{'timers.cluster.active' | translate }}</b></span>
          <span class="m-l-md" *ngIf="isActiveNode">{{'General.yes' | translate }}</span>
          <span class="m-l-md" *ngIf="!isActiveNode">{{'General.no' | translate }}</span>
        </div>
      </div>
    </div>
    <div class="row m-t-md">
      <div class="col-12 ">
        <p-panel>
          <p-header> <button class="btn btn-primary" (click)="loadTimers()">
              <i class="fas fa-sync-alt"></i> {{ 'General.reload' | translate }} </button>
            <!-- <i class="fa fa-file" aria-hidden="true"></i> Timers -->
            <span class="leyenda float-right">{{ 'Audit.total' | translate }} {{ timers ? timers.length : '0' }}
              timers</span>
          </p-header>
          <p-table [value]="timers" sortField="actualStatus" sortOrder="1" [paginator]="false"
            class="footer-over-pagination">
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="7"> {{ 'General.noData' | translate }} </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="configurationStatus" [style]="{ width: '100px' }" styleClass="text-center">{{
                  'timers.configuration' | translate }}<p-sortIcon field="configurationStatus"></p-sortIcon>
                </th>
                <th pSortableColumn="actualStatus" [style]="{ width: '100px' }" styleClass="text-center">{{
                  'timers.status' | translate }}<p-sortIcon field="actualStatus"></p-sortIcon>
                <th pSortableColumn="identifier" styleClass="col-2">Id <p-sortIcon field="identifier">
                  </p-sortIcon>
                </th>
                <th styleClass="col-1 text-center">Fechas</th>
                <th pSortableColumn="idleTime">Periodicidad <p-sortIcon field="idleTime">
                  </p-sortIcon>
                </th>
                <th pSortableColumn="initialStartDate" styleClass="col-1 text-center">Arranque <p-sortIcon
                    field="initialStartDate">
                  </p-sortIcon>
                </th>
                <th styleClass="text-right action-column">
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-timer>
              <tr>
                <td field="configurationStatus">
                  <!-- RUNNING -->
                  <span *ngIf="timer.configurationStatus === 'started'"> {{ 'timers.started' | translate }} </span>
                  <!-- STOPPED -->
                  <span *ngIf="timer.configurationStatus === 'stopped'"> {{ 'timers.stopped' | translate }} </span>
                </td>
                <td field="actualStatus">
                  <!-- RUNNING -->
                  <span *ngIf="timer.actualStatus === 'started'" style="color:green">
                    <i class="fas fa-play" aria-hidden="true"></i>
                  </span>
                  <!-- STOPPED -->
                  <span *ngIf="timer.actualStatus === 'stopped'" style="color:black">
                    <i class="fa fa-stop" aria-hidden="true"></i>
                  </span>
                  <!-- ERROR -->
                  <span *ngIf="timer.actualStatus === 'error'" style="color:red">
                    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                  </span>
                </td>
                <td field="identifier">
                  {{timer.identifier}}
                </td>
                <td>
                  <div *ngFor="let execDate of timer.nextExecutions"> {{ execDate.schedule | date: 'dd/MM/yyyy
                    HH:mm:ss'
                    }} </div>
                </td>
                <td field="idleTime">
                  <span *ngIf="timer.idleTime">{{ timer.idleTime | number }}</span>
                  <span *ngIf="timer.schedulerExpression">{{ timer.schedulerExpression }}</span>
                </td>
                <td field="initialStartDate">
                  {{timer.initialStartDate}}
                </td>
                <td>
                  <button *ngIf="timer.configurationStatus === 'stopped'" class="btn btn-xs btn-default"
                    style="width: 100%" aria-expanded="false" (click)="updateTimerStatus(timer, true)">
                    <i class="fas fa-play" aria-hidden="true"></i> Start </button>
                  <button *ngIf="timer.configurationStatus === 'started'" class="btn btn-xs btn-default"
                    style="width: 100%" aria-expanded="false" (click)="updateTimerStatus(timer, false)">
                    <i class="fa fa-stop" aria-hidden="true"></i> Stop </button>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </p-panel>
      </div>
    </div>
  </div>
</div>